import { useStore } from '../store/useStore'

export const useSidebarState = (): useSidebarStateResult =>
  useStore<boolean>('sidebar.open', false)

export type useSidebarStateResult = [boolean, (open: boolean) => void]
